import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Cabeçalho das seções da vitrine: título forte, uma linha de contexto e a ação
 * "Ver todas" à direita.
 *
 * A ação aceita `to` (vai para outra rota) ou `onClick` (muda algo na própria
 * página, como a aba do feed). Sem destino real, a ação não aparece.
 */
export default function SectionHeader({ titulo, subtitulo, acao, id }) {
    const botao = acao && (acao.to
        ? <Link to={acao.to} className="sv-btn-ghost shrink-0">{acao.label}</Link>
        : acao.onClick
            ? <button type="button" onClick={acao.onClick} className="sv-btn-ghost shrink-0">{acao.label}</button>
            : null);

    return (
        <div className="sv-section-head">
            <div className="min-w-0">
                <h2 className="sv-h2" id={id}>{titulo}</h2>
                {subtitulo && <p className="sv-sub">{subtitulo}</p>}
            </div>
            {botao}
        </div>
    );
}
